import {
  Utensils, Stethoscope, Pill, Scissors, ToyBrick, ShieldCheck, GraduationCap, Sparkles,
  Syringe, HeartPulse, Fingerprint, Receipt, FolderOpen,
} from "lucide-react";

export const EXPENSE_CATS = [
  { id: "cibo",          label: "Cibo",              icon: Utensils,      color: "#FF7A1A" },
  { id: "veterinario",   label: "Veterinario",       icon: Stethoscope,   color: "#E94545" },
  { id: "farmaci",       label: "Farmaci",           icon: Pill,          color: "#7B61FF" },
  { id: "toelettatura",  label: "Toelettatura",      icon: Scissors,      color: "#EC4899" },
  { id: "accessori",     label: "Accessori & giochi", icon: ToyBrick,     color: "#0EA5E9" },
  { id: "assicurazione", label: "Assicurazione",     icon: ShieldCheck,   color: "#2DBA60" },
  { id: "addestramento", label: "Addestramento / Pensione", icon: GraduationCap, color: "#B37016" },
  { id: "extra",         label: "Extra",             icon: Sparkles,      color: "#9A9A9A" },
];
export const EXPENSE_BY = Object.fromEntries(EXPENSE_CATS.map((c) => [c.id, c]));

export const PERIODS = [
  { id: "week",  label: "Settimana", short: "questa settimana", prev: "settimana scorsa" },
  { id: "month", label: "Mese",      short: "questo mese",      prev: "mese scorso" },
  { id: "year",  label: "Anno",      short: "quest'anno",       prev: "anno scorso" },
];

export const DOC_CATS = [
  { id: "vaccino",       label: "Vaccino" },
  { id: "libretto",      label: "Libretto sanitario" },
  { id: "referto",       label: "Referto / analisi" },
  { id: "ricetta",       label: "Ricetta" },
  { id: "microchip",     label: "Microchip / anagrafe" },
  { id: "pedigree",      label: "Pedigree" },
  { id: "proprieta",     label: "Proprietà" },
  { id: "fattura",       label: "Fattura / ricevuta" },
  { id: "assicurazione", label: "Assicurazione" },
  { id: "altro",         label: "Altro" },
];
export const DOC_CAT_LABEL = Object.fromEntries(DOC_CATS.map((c) => [c.id, c.label]));

export const DOC_SECTIONS = [
  { id: "vaccini",       title: "Vaccini",           sub: "Certificati e richiami",      icon: Syringe,     color: "#2DBA60", cats: ["vaccino"] },
  { id: "salute",        title: "Salute & Libretto", sub: "Libretto, referti, ricette",  icon: HeartPulse,  color: "#E94545", cats: ["libretto", "referto", "ricetta"] },
  { id: "identita",      title: "Identità",          sub: "Microchip, pedigree, proprietà", icon: Fingerprint, color: "#7B61FF", cats: ["microchip", "pedigree", "proprieta"] },
  { id: "fatture",       title: "Fatture",           sub: "Ricevute e scontrini",        icon: Receipt,     color: "#FF7A1A", cats: ["fattura"] },
  { id: "assicurazione", title: "Assicurazione",     sub: "Polizze e coperture",         icon: ShieldCheck, color: "#0EA5E9", cats: ["assicurazione"] },
  { id: "altro",         title: "Altro",             sub: "Tutto il resto",              icon: FolderOpen,  color: "#9A9A9A", cats: ["altro"] },
];

export const fmtEur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n || 0);

export const daysTo = (date) =>
  date ? Math.ceil((new Date(date) - new Date()) / 86400000) : null;
